import { create } from "zustand";

const IssueStore = create((set) => ({
  selectedIssue: null,

  setSelectedIssue: (issue) =>
    set({ selectedIssue: issue }),

  clearSelectedIssue: () =>
    set({ selectedIssue: null }),
}));

export default IssueStore;